"use client";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { RootState } from "../../../store/store";
import { ImageContent } from "../../../assets/background/background";
import clsx from "clsx";
import { BANNER_TYPE } from "../../cms-website/website-structure/content/enum/content.enum";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import {
    Box,
    Button,
    Divider,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import ContainerButton from "../../../components/button/ContainerButton";
import HtmlRenderer from "../../../components/render-html/RenderHtml";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import { ContentApi } from "@/api/content/content.api";
import { decode } from "html-entities";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { activityList, FrontApi } from "../../../api/front-api/front.api";
import { routeName } from "../../../routes/routeName";
import { decodeId, shareToFacebook, shareToLine, shareToX } from "../../../utils/app.utils";
// import PreviewImage from "../../../components/preview-image/PreviewImage";
import BannerSlide from "../../../components/banner-slide/BannerSlide";
import moment from "moment";
import SharedContent from "../../../components/shared/SharedContent";
import DownloadIcon from '@mui/icons-material/Download';
import { OptionContent } from "../../../components/option-content/option_content";
import { exportToWord } from "./element/export_data";
import { ContentCard } from "./element/element";
import Hashids from "hashids";
import { likeContent, SOCIAL_MEDIA_TYPE } from "../../../utils/global.func";
import { MainContainer } from "../../../components/container/container";
import { htmlToPlainText } from "../../../components/render-html/func";
import { useTranslation } from "react-i18next";


type Props = {};
const chunkArray = (array: any[], size: number) => {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
        array.slice(index * size, index * size + size)
    );
};

const ActivityDetail: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const mode = theme.palette.mode;
    const { id } = useParams();
    const dispatch = useDispatch();
    // const [searchParams] = useSearchParams();


    const id_content = decodeId(id ?? "");
    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);

    const baseApi = useSelector((state: RootState) => state.api.image_api);
    const baseApi_content = useSelector(
        (state: RootState) => state.api.public_content_api
    );
    const current_path = location.pathname;
    const content_url = baseApi_content + current_path

    const matches = useMediaQuery(theme.breakpoints.down("lg"));
    const nextRef = useRef<HTMLDivElement>(null);
    const preRef = useRef<HTMLDivElement>(null);

    const [warning_detail, set_warning_detail] = useState<any>(null);
    const [banner_type, set_banner_type] = useState<string>("");
    const [media_file, set_media_file] = useState<any[]>([]);
    const [related_contents, set_related_contents] = useState<any[]>([]);

    const handleInit = (swiper: any) => {
        if (preRef.current && nextRef.current) {
            swiper.params.navigation.prevEl = preRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
        }
    };

    const handleGetContentDetail = async (id_content: number) => {
        dispatch(setLoading());
        await FrontApi.findOneContent(id_content)
            .then((res) => {
                if (res.status < 300) {
                    set_warning_detail(res.data?.data || null);
                    set_banner_type(res.data?.data?.banner_type || "");
                    const media_file = Array.isArray(res.data?.data?.content_files)
                        ? res.data?.data?.content_files?.map((list: any) => {
                            return {
                                ...list,
                                ...list?.media_file
                            }
                        })
                        : [];
                    set_media_file(media_file);
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    };
    const handleGetRelatedContent = useCallback(async () => {
        let query: activityList = {
            page: 1,
            limit: 4,
        }
        if (id_content) query.id_content = id_content
        await FrontApi.activity(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_related_contents(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [id_content])

    // const isHTMLString = (str: string): boolean => {
    //     const htmlRegex = /<\/?[a-z][\s\S]*>/i;
    //     return htmlRegex.test(str);
    // };

    // const isHTML = isHTMLString(warning_detail?.content_name ?? "");
    const content_detail_html = decode(
        warning_detail?.content_detail || ""
    ).replace(/”/g, '"'); // แก้ quote

    useEffect(() => {
        if (id_content) {
            handleGetRelatedContent();
        }
    }, [handleGetRelatedContent])
    useEffect(() => {
        window.scrollTo({ top: 2, behavior: "smooth" });
        if (id_content) {
            handleGetContentDetail(id_content);
        }
    }, [id_content]);

    // const chunks: any[] = chunkArray(media_file?.length > 0 ? media_file : [], 4);
    const encodeId = (id_content: number) => {
        const id = hash_ids.encode(id_content);
        navigate(routeName.main.activityDetail.replace(":id", id))
    }
    const content_path_recommend = `${content_url}/${routeName.main.activityDetail.replace(":id", `${id}`)}`;
    return (
        <>
            <Box
                sx={{
                    backgroundColor: mode === "dark" ? "black" : "white",
                }}
                component={"main"}
                className="w-full"
            >
                <BannerSlide
                    banner_type={warning_detail?.banner_type}
                    disabled_link
                    banner_slide={media_file}
                />
                <MainContainer>
                    {warning_detail?.content_name && (
                        <section>
                            <Typography
                                sx={{
                                    color: (theme) => theme.palette.text.primary,
                                    my: 4,
                                    textAlign: "center",
                                }}
                                variant="h4"
                            >
                                {warning_detail?.content_name || "-"}
                            </Typography>

                            {warning_detail?.content_desc && (
                                <Typography
                                    variant="h6"
                                    sx={{
                                        mb: 4,
                                        textAlign: "center",
                                        fontSize: "14px",
                                        color: (theme) => theme.palette.text.primary,
                                    }}
                                >
                                    {warning_detail?.content_desc || "-"}
                                </Typography>
                            )}

                            <Divider />
                        </section>
                    )}
                    <section className="grid grid-cols-12 gap-8">
                        <article
                            className={clsx("col-span-12 ", {
                                "md:col-span-8": banner_type === BANNER_TYPE.TYPE_THREE,
                            })}
                        >
                            <section className={clsx("w-full flex flex-col mt-0")}>
                                <HtmlRenderer html={content_detail_html} />
                            </section>

                            <Typography sx={{ fontSize: "14px", color: "#828282" }}>
                                {t("ระยะเวลาที่จัดกิจกรรม :")} {warning_detail?.activity_start_date ? moment(warning_detail?.activity_start_date).format("DD/MM/YY") : ""} {" "}
                                {t("เวลา :")} {moment(warning_detail?.activity_start_date).format("HH:mm")}
                            </Typography>
                            <Button onClick={() => exportToWord({
                                content_detail: warning_detail?.content_detail,
                                content_end_date: warning_detail?.activity_end_date,
                                content_name: warning_detail?.content_name || "",
                                content_start_date: warning_detail?.activity_start_date
                            })} color="success" variant="contained" fullWidth sx={{ maxWidth: "fit-content", my: 4 }} endIcon={<DownloadIcon />}>
                                {t("ดาวน์โหลดรายละเอียด")}
                            </Button>
                            <Box className="flex flex-col md:flex-row justify-between items-center">
                                <span>
                                    <OptionContent
                                        date={warning_detail?.activity_start_date || ""}
                                        count={{
                                            like: +warning_detail?.total_like || 0,
                                            like_checked: +warning_detail?.is_like ? true : false,
                                            shared: +warning_detail?.total_shared || 0,
                                            view: +warning_detail?.total_view || 0,
                                            onLikeClick: () => likeContent(warning_detail?.id_content, +warning_detail?.is_like ? 'DISLIKE' : 'LIKE', 'CONTENT', (st, id, type) => {
                                                set_warning_detail((prev: any) => ({
                                                    ...prev,
                                                    total_like: type === 'LIKE' ? +prev?.total_like + 1 : +prev?.total_like - 1,
                                                    is_like: type === 'LIKE' ? true : false
                                                }))
                                            }),
                                            onSharedClick: {
                                                facebookClick: () => {
                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                        set_warning_detail((sp: any) => ({
                                                            ...sp,
                                                            total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                                    shareToFacebook(content_path_recommend)
                                                },
                                                lineClick: () => {
                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                        set_warning_detail((sp: any) => ({
                                                            ...sp,
                                                            total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.LINE)
                                                    shareToLine(content_path_recommend, warning_detail?.content_name);
                                                },
                                                xClick: () => {
                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                        set_warning_detail((sp: any) => ({
                                                            ...sp,
                                                            total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.X)
                                                    shareToX(content_path_recommend, warning_detail?.content_name)
                                                },
                                            }
                                        }}
                                    />
                                </span>
                                <span>
                                    <SharedContent
                                        facebook_link={content_url}
                                        line_link={content_url}
                                        textLine={warning_detail?.content_name || ""}
                                        textX={warning_detail?.content_name || ""}
                                        x_link={content_url}
                                        copy={content_url}
                                    />
                                </span>
                            </Box>
                            {related_contents?.length > 0 && (
                                <Box py={5}>
                                    <Typography mb={4} variant="h5">{t("กิจกรรมแนะนำ")}</Typography>
                                    <ContentCard
                                        modeHorizontal
                                        onChange={(id_content) => {
                                            encodeId(id_content);
                                        }}
                                        data={related_contents?.map((list) => {
                                            const url_img = `${baseApi}/${list?.media_file_path}/${list?.media_file_name}`;
                                            const id = hash_ids.encode(list?.id_content);
                                            const content_path_recommend = `${baseApi_content}/${routeName.main.activityDetail.replace(":id", id)}`;
                                            const detail_text = htmlToPlainText(list?.content_detail);
                                            return {
                                                id_key: list?.id_content,
                                                content_status_name: list?.content_status_name,
                                                detail: detail_text,
                                                group_name: list?.activity_category_name || "-",
                                                img_url: url_img,
                                                title: list?.content_name || "-",
                                                alt: list?.content_name,
                                                date: list?.activity_start_date,
                                                shared: +list?.total_shared ? +list?.total_shared : 0,
                                                view: list?.view_total ? list?.view_total : 0,
                                                like: list?.total_like ? +list?.total_like : 0,
                                                like_checked: !!list?.is_like,
                                                onLike: () => likeContent(list?.id_content, +list?.is_like ? 'DISLIKE' : 'LIKE', 'CONTENT', (st, id, type) => {
                                                    set_related_contents(prev => prev.map((sp) => {
                                                        return sp?.id_content === id ? {
                                                            ...sp,
                                                            total_like: type === 'LIKE' ? +sp?.total_like + 1 : +sp?.total_like - 1,
                                                            is_like: type === 'LIKE' ? true : false
                                                        } : sp
                                                    }))
                                                }),
                                                onShared: {
                                                    facebookClick: () => {
                                                        likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                            set_related_contents(prev => prev.map((sp) => {
                                                                return sp?.id_content === id ? {
                                                                    ...sp,
                                                                    total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                } : sp
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                                        shareToFacebook(content_path_recommend)
                                                    },
                                                    lineClick: () => {
                                                        likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                            set_related_contents(prev => prev.map((sp) => {
                                                                return sp?.id_content === id ? {
                                                                    ...sp,
                                                                    total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                } : sp
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.LINE)
                                                        shareToLine(content_path_recommend, list?.content_name);
                                                    },
                                                    xClick: () => {
                                                        likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                            set_related_contents(prev => prev.map((sp) => {
                                                                return sp?.id_content === id ? {
                                                                    ...sp,
                                                                    total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                } : sp
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.X)
                                                        shareToX(content_path_recommend, list?.content_name)
                                                    },
                                                }
                                            }
                                        })}
                                    />
                                </Box>
                            )}
                            <ContainerButton
                                sxContainer={{ my: 10 }}
                                buttonData={[
                                    {
                                        seq: 1,
                                        key: "BACK",
                                        buttonProps: {
                                            sx: {
                                                borderRadius: "48px",
                                            },
                                            onClick: () => {
                                                if (window.history.length > 1) {
                                                    navigate(-1);
                                                } else {
                                                    navigate(routeName.main.activity);
                                                }
                                            },
                                        },
                                        // borderRadius: 48,
                                        label: t("ย้อนกลับ"),
                                        type: "BACK",
                                    },
                                ]}
                            />
                        </article>
                        {banner_type === BANNER_TYPE.TYPE_THREE && (
                            <article className={clsx("relative col-span-4 h-screen", {})}>
                                <div
                                    ref={preRef}
                                    style={{
                                        backgroundColor: "#4A4A4A",
                                        color: "white",
                                    }}
                                    className={clsx(
                                        "absolute p-1 rounded-[50%] top-0 left-[50%] translate-x-[-50%] z-10 cursor-pointer",
                                        {
                                            hidden: matches,
                                        }
                                    )}
                                >
                                    <KeyboardArrowUpIcon />
                                </div>

                                <div
                                    ref={nextRef}
                                    style={{
                                        backgroundColor: "#4A4A4A",
                                        color: "white",
                                    }}
                                    className={clsx(
                                        "absolute p-1 rounded-[50%] bottom-0 left-[50%] translate-x-[-50%] z-10 cursor-pointer",
                                        {
                                            hidden: matches,
                                        }
                                    )}
                                >
                                    <KeyboardArrowDownIcon />
                                </div>
                                <Swiper
                                    direction={matches ? "horizontal" : "vertical"}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    navigation={{
                                        nextEl: nextRef.current,
                                        prevEl: preRef.current,
                                    }}
                                    spaceBetween={10}
                                    slidesPerView={matches ? 1 : 2}
                                    modules={[Pagination, Navigation]}
                                    className="mySwiper cursor-grab"
                                    onInit={handleInit}
                                >
                                    {media_file?.map((list, index) => {
                                        const id = `key_${index}`;
                                        return (
                                            <SwiperSlide
                                                style={{ overflow: "hidden" }}
                                                className="relative"
                                                key={id}
                                            >
                                                <div className="w-full h-fit border-4 border-white shadow-md">
                                                    <img
                                                        className="object-cover"
                                                        width={"100%"}
                                                        src={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`}
                                                        alt="image"
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                            </article>
                        )}
                    </section>
                </MainContainer>
            </Box>
        </>
    );
};

export default ActivityDetail;
